










// Bind all Variant IDs for the upsell page 


const explorerClipVIds = '46868704461021,46868704493789,46868704526557'.split(',');
const bundleCollVIds = '46623170953437,46359655678173,47044722720989'.split(',');
const activeFitWatchBandVIds = '40760456085672,40760456118440,40760456151208,40760456183976,40760456216744'.split(',');
const comforFitWatchBandVIds = '43524127752413,43524148920541,43524159045853,43524179787997,43524192338141,43524212326621,43524218388701,44407846568157,44407846600925'.split(',');
const chargingAccsVIds = '45291212701917,43184033890525'.split(',');
const screenProtectorVIds = '46868630798557'.split(',');
const UPSELL_VARIANT_IDS = '40760456085672,40760456118440,40760456151208,40760456183976,40760456216744,43524127752413,43524148920541,43524159045853,43524179787997,43524192338141,43524212326621,43524218388701,44407846568157,44407846600925,45291212701917,43184033890525,46868630798557,46623170953437,46359655678173,47044722720989,46868704461021,46868704493789,46868704526557'.split(',');

// Get Plan Variant IDs and their details
const planVIds = '46926279114973:1 Year Membership'.split(',').map(item => {
  const [id, name, duration_text] = item.split(':'); // Split the string at ":"
  return { id, name, duration_text };
});

// Cosmo Care Variant ID & Selling Plan ID
const cosmoCareVariantId = 46892709707997; // COSMO Care - Monthly
const cosmoCareSellingPlanId = 6194397405 // Delivery every 30 Days

const cosmoCarePlusVariantId = 46892711510237; // COSMO Care - Plus
const cosmoCarePlusSellingPlanId = 6190727389 // Delivery every 30 Days
var addedCosmoCareDetails = null;
var addedCosmoCare = 0; 
// Declaring Hassle Free Return Product ID - Not Variant Id
const hassleFreeProductVId = ["8852089438429"];

// Activation Fee Variant Product
const activationFeeVId = 43795278954717;

// Watch Variant ID "1000 hours outside bundle"
const watchVId = 46874326139101;

// Declaring the Cart Data
let cartData = null;

$(document).ready(async (e) => {
  await fetchCart();

  // bindCartData();
})

function bindCartData() {
  $('.add-more').hide();
  let cosmoCareAdded = false
  let cosmoCarePrice = 0
  let addedPlanDetails = null;
  let addedPlanPrice = 0
  addedCosmoCare=0

  let activeFitWatchBandCartQty = activeFitWatchBandCartPrice = 0;
  let comforFitWatchBandCartQty = comforFitWatchBandCartPrice = 0;
  let chargingAccsCartQty = chargingAccsCartPrice = 0;
  let screenProtectorCartQty = screenProtectorCartPrice = 0;
  
  $('.accessories-box')?.find('.accessories-items')?.html('');
  $('.checkoutsummary')?.find('.pricing-info')?.html('');
  $('.renew_txt').text('');

  for (const cartItem of cartData?.items ?? []) {
    console.log(cartItem);
    const cartItemVariantId = cartItem.variant_id.toString();
    const cartItemProductId = cartItem.product_id.toString();

    let addItemToReview = true;
    let alwaysShowQtyToReview = false;
    let reviewItemTitle = cartItem?.title;
   
   
    if (UPSELL_VARIANT_IDS.includes(cartItemVariantId) || hassleFreeProductVId.includes(cartItemProductId)) {
      
      let variantTitle = cartItem?.title;

      if (screenProtectorVIds.includes(cartItemVariantId)) {
        addItemToReview = false;
        screenProtectorCartQty += cartItem?.quantity;
        screenProtectorCartPrice += cartItem?.final_line_price ? parseFloat(cartItem?.final_line_price / 100) : "0.0";
      } else if (chargingAccsVIds.includes(cartItemVariantId)) {
        // addItemToReview = false;
        // chargingAccsCartQty += cartItem?.quantity;            
        // chargingAccsCartPrice += cartItem?.final_line_price ? parseFloat(cartItem?.final_line_price / 100) : 0;
        alwaysShowQtyToReview = true;

        variantTitle = `${variantTitle}`;
      } else if (activeFitWatchBandVIds.includes(cartItemVariantId)) {
        addItemToReview = false;
        activeFitWatchBandCartQty += cartItem?.quantity;            
        activeFitWatchBandCartPrice += cartItem?.final_line_price ? parseFloat(cartItem?.final_line_price / 100) : 0;

        variantTitle = `ActiveFit Band`;
        
        let selectedColor = cartItem?.options_with_values.find((obj) => {
          return obj.name == "Color";
        });

        if (selectedColor) {
          variantTitle += ` - ${selectedColor?.value.split(' ')[0]}`
        }
      } else if (comforFitWatchBandVIds.includes(cartItemVariantId)) {
        addItemToReview = false;
        comforFitWatchBandCartQty += cartItem?.quantity;            
        comforFitWatchBandCartPrice += cartItem?.final_line_price ? parseFloat(cartItem?.final_line_price / 100) : 0;
        
        variantTitle = `ComfortFit Band`;

        let selectedColor = cartItem?.options_with_values.find((obj) => {
          return obj.name == "Color";
        });

        if (selectedColor) {
          variantTitle += ` - ${selectedColor?.value.split(' ')[0]}`
        }
      } else if (hassleFreeProductVId.includes(cartItemProductId)) {
        reviewItemTitle = `Hassle Free Returns`;
        variantTitle = `Hassle Free Returns & Package Protection`;
      }
    
      const html = `<div class="assesories-wrapper" id="item_${ cartItemVariantId }">
                <div class="access-img">
                  <img src="${ cartItem?.image }" alt="${ cartItem?.handle }">
                </div>
                <div class="access-info">
                  <h3>
                    <span class="acess-name">${ variantTitle }</span>
                    <span class="acess-price" id="price_${ cartItemVariantId }"><span class="money">$${ cartItem?.final_price ? parseFloat(cartItem?.final_price / 100).toFixed(2) : "0.0" }</span></span>                        
                  </h3>
                  <p>
                    <button class="btn removebtn" onclick="removeAccessory('${cartItemVariantId}', '${ cartItem.id }')">
                      <span id="removetext"><span class="spinner"></span><i><img src="//cosmotogether.com/cdn/shop/t/46/assets/remove.svg?v=125138519382385159881762492637"></i><span id="removetext_new">Remove</span></span>
                    </button>
                  </p>
                </div>
              </div>`

      $('.accessories-box')?.find('.accessories-items')?.append(html);
      $('.add-more').show();
    }
  
    else if (planDetails = planVIds.find(obj => { return obj.id == cartItemVariantId })) {
      //alert('plan');
      $('#plan-details')?.find('.access-info')?.find('.acess-name')?.text(planDetails.name);
      $('#plan-details')?.find('.access-info')?.find('.acess-price')?.html(`<span class="money">$${ cartItem?.final_price ? parseFloat(cartItem?.final_price / 100) : "0.0" }</span>`);
 
      addedPlanDetails = planDetails;
      addedPlanPrice = cartItem?.final_price ? parseFloat(cartItem?.final_price / 100) : 0;

      reviewItemTitle = `${ planDetails.name }`
    } else if (cartItemVariantId == cosmoCareVariantId) {
     // alert('cART');
      cosmoCareAdded = true;
      cosmoCarePrice = cartItem?.final_price ? parseFloat(cartItem?.final_price / 100) : 0;
      addedCosmoCare=1;
       //alert(addedCosmoCare);
      $('#cosmocare-details')?.find('.access-info')?.find('#cosmocareprice')?.html(`<span class="money">$${ cartItem?.final_price ? parseFloat(cartItem?.final_price / 100) : "0.0" }</span>/mo`);
      $('#cosmocare-details')?.find('.access-info')?.find('.acess-name')?.text('Basic Coverage');
      $('#cosmo-damage').text('(Damage)');
      
      reviewItemTitle = `Cosmo Care Basic`
    }
    else if (cartItemVariantId == cosmoCarePlusVariantId) {
     //  alert('cART 2');
      cosmoCareAdded = true;
      cosmoCarePrice = cartItem?.final_price ? parseFloat(cartItem?.final_price / 100) : 0;
      addedCosmoCare=2;
     // alert(addedCosmoCare);
      $('#cosmocare-details')?.find('.access-info')?.find('#cosmocareprice')?.html(`<span class="money">$${ cartItem?.final_price ? parseFloat(cartItem?.final_price / 100) : "0.0" }</span>/mo`);
      $('#cosmocare-details')?.find('.access-info')?.find('.acess-name')?.text('Plus Coverage');
      $('#cosmo-damage').text('(Damage, Loss, Theft)');
      
      reviewItemTitle = `Cosmo Care Plus`
    }
    else if (cartItemVariantId == activationFeeVId) {
      reviewItemTitle = `Activation fee (one-time)`
    } else if (cartItemVariantId == watchVId) { 
      //alert('radhe')
      reviewItemTitle = `JrTrack 5 Kids Smartwatch`
     // alert(reviewItemTitle);
      $('span#watchprice')?.html(`<span class="money">$${ cartItem?.final_price ? parseFloat(cartItem?.final_price / 100) : "0.0" }</span>`)
    } else {
      // console.log('cartItemVariantId: ', cartItemVariantId)
    }

    if (addItemToReview == true) {
      $('.checkoutsummary')?.find('.pricing-info')?.append(`<p class="pricerow">
                <span class="suminfo">${ reviewItemTitle } ${ ( cartItem?.quantity > 1 || alwaysShowQtyToReview == true ) ? `(x${cartItem?.quantity})` : '' }</span>
                <span class="sumprice"><span class="money">$${ cartItem?.final_line_price ? parseFloat(cartItem?.final_line_price / 100).toFixed(2) : "0.0" }</span></span>
              </p>`);  
    }
  }
        
  $('.checkoutsummary')?.find('.totalpricing')?.find('.totalprice')?.html(`<span class="money">$${ cartData?.total_price ? parseFloat(cartData?.total_price / 100).toFixed(2) : "0.0" }</span>`);
  //alert(cosmoCareAdded);
  if(cosmoCareAdded == true) {
    $('#cosmocare-details')?.find('.bottominfo')?.show();
    $('#cosmocare-details')?.find('#removecosmo')?.show();
    $('#cosmocare-details')?.next('.addProtection')?.hide();
    $('#cosmocare-details')?.find('.assesories-wrapper')?.show();

    switch (addedPlanDetails?.id) {
      case '46926279114973': // 1-year membership
        $('.renew_txt').html(
          `Your Cosmo Membership will renew for <span class="money">$${ addedPlanPrice.toFixed(2) }</span> on ${ moment().add(14, 'months').format('MMMM Do YYYY') }.  Your Cosmo Care coverage will bill <span class="money">$${ cosmoCarePrice }</span> per month until canceled.`
        );
        break;
    }
  } else {
   // alert(cosmoCareAdded);
    $('#cosmocare-details')?.find('.bottominfo')?.hide();
    $('#cosmocare-details')?.find('#removecosmo')?.hide();
    $('#cosmocare-details')?.next('.addProtection')?.show();
    $('#cosmocare-details')?.find('.assesories-wrapper')?.hide();


    switch (addedPlanDetails?.id) {
      case '46926279114973': // 1-year membership
        $('.renew_txt').html(
          `Your Cosmo Membership will renew for <span class="money">$${ addedPlanPrice.toFixed(2) }</span> on ${ moment().add(14, 'months').format('MMMM Do YYYY') }.`
        );
        break;
    }
  }

  if (activeFitWatchBandCartQty > 0) {
    $('.checkoutsummary')?.find('.pricing-info')?.append(`<p class="pricerow">
                <span class="suminfo">ActiveFit Band (x${activeFitWatchBandCartQty})</span>
                <span class="sumprice"><span class="money">$${ activeFitWatchBandCartPrice.toFixed(2) ?? "0.0" }</span></span>
              </p>`);  
  }

  if (comforFitWatchBandCartQty > 0) {
    $('.checkoutsummary')?.find('.pricing-info')?.append(`<p class="pricerow">
                <span class="suminfo">ComfortFit Band (x${comforFitWatchBandCartQty})</span>
                <span class="sumprice"><span class="money">$${ comforFitWatchBandCartPrice.toFixed(2) ?? "0.0" }</span></span>
              </p>`);  
  }

  if (chargingAccsCartQty > 0) {
    $('.checkoutsummary')?.find('.pricing-info')?.append(`<p class="pricerow">
                <span class="suminfo">Charging Accessories (x${chargingAccsCartQty})</span>
                <span class="sumprice"><span class="money">$${ chargingAccsCartPrice.toFixed(2) ?? "0.0" }</span></span>
              </p>`);  
  }

  if (screenProtectorCartQty > 0) {
    $('.checkoutsummary')?.find('.pricing-info')?.append(`<p class="pricerow">
                <span class="suminfo">Screen Protector (x${screenProtectorCartQty})</span>
                <span class="sumprice"><span class="money">$${ screenProtectorCartPrice.toFixed(2) ?? "0.0" }</span></span>
              </p>`);  
  }


   if (cosmoCareAdded) {
    $('#plan-details')?.find('.editbtn')?.show();
  } else {
    $('#plan-details')?.find('.editbtn')?.hide();
  }
}

function fetchCart() {
  return new Promise((resolve, reject) => {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {          
      cartData = cart ?? null;
      console.log('cartData: ', cartData);
      bindCartData();
      return resolve(cartData);
    })
    .catch(error => {
      // showErrorMessage(error, "Cart Retrieval Failed");
      console.error('Error fetching cart data:', error);
    });
  })
}

async function addCosmoCare(param, ele) {
  if (cartData) {
    $(ele).attr('disabled', 'disabled')
    if (param == 1 || param == 2) {
      $('#cosmocare-details')?.find('.addProtection')?.find('button.protectionBox')?.find('.spinner')?.show();
      $('#cosmocare-details')?.find('.addProtection')?.find('button.protectionBox')?.find('.text')?.text('Adding protection');
    } else {
      $('#cosmocare-details')?.find('.removebtn')?.find('.spinner')?.show();
      $('#cosmocare-details')?.find('.removebtn')?.find('img')?.hide();          
      $('#cosmocare-details')?.find('.removebtn')?.find('.removetext')?.html('Removing');
    }        

    const cosmoCareCartItem = (cartData?.items ?? []).find((obj) => {
        if(obj.variant_id == cosmoCareVariantId || obj.variant_id == cosmoCarePlusVariantId)
        {
            return obj.variant_id
        }
     // return obj.variant_id == (cosmoCareVariantId || cosmoCarePlusVariantId);
    })

    if (cosmoCareCartItem) {
      await removeCartItem(cosmoCareCartItem?.id);
    }
    
    if (param == 2) {
      if (await addCartItem({
        id: cosmoCarePlusVariantId,
        selling_plan: cosmoCarePlusSellingPlanId,
        quantity: 1,
      })) {
        localStorage.setItem('cosmocare', 1);            
      }
    } 
    else if (param == 1) {
      if (await addCartItem({
        id: cosmoCareVariantId,
        selling_plan: cosmoCareSellingPlanId,
        quantity: 1,
      })) {
        localStorage.setItem('cosmocare', 1);            
      }
    } else {
      localStorage.setItem('cosmocare', 0);
    }

    await fetchCart();
    
    $(ele).removeAttr('disabled');
    if (param == 1) {
      $('#cosmocare-details')?.find('.addProtection')?.find('button.protectionBox')?.find('.spinner')?.hide();
      $('#cosmocare-details')?.find('.addProtection')?.find('button.protectionBox')?.find('.text')?.text('Add protection');
    } else {
      $('#cosmocare-details')?.find('.removebtn')?.find('.spinner')?.hide();
      $('#cosmocare-details')?.find('.removebtn')?.find('img')?.show();
    }
  }
}

async function removeAccessory(variant_id, lineItemId) {
  $(`#item_${variant_id}`).find("button.removebtn").attr('disabled', 'disabled');
  $(`#item_${variant_id}`).find("button.removebtn").children("#removetext").find("#removetext_new").text('Removing');
  $(`#item_${variant_id}`).find("button.removebtn").children("#removetext").children('.spinner').show();

  if (await removeCartItem(lineItemId)) {        
    fetchCart();
  }
  
  $(`#item_${variant_id}`)?.find("button.removebtn")?.removeAttr('disabled');
  //$(`#item_${variant_id}`)?.find("button.removebtn")?.children("#removetext")?.text('Remove');
  $("#removetext_new").text('Remove');
  $(`#item_${variant_id}`)?.find("button.removebtn")?.children('.spinner')?.hide();
}

function removeCartItem(lineItemId) {
  return new Promise((resolve, reject) => {
    const payload = {
      updates : {}
    };
    
    if(Array.isArray(lineItemId)) {
      lineItemId.forEach(id => {
        payload.updates[lineItemId] = 0            
      });
    } else {
      payload.updates[lineItemId] = 0
    }

    jQuery.post('/cart/update.js', payload).done(function () {
      return resolve(true);
    }).fail(function(xhr, status, error) {
      showErrorMessage(error, "Oops! Removal Failed");
      return resolve(false);
    });
  })
}

function addCartItem(lineItem) {
  return new Promise((resolve, reject) => {
    jQuery.post('/cart/add.js', {
      items: Array.isArray(lineItem) ? lineItem : [lineItem]
    }).done(function (e) {
      return resolve(true);
    }).fail(function(xhr, status, error) {
      showErrorMessage(error, "Failed to Add to Cart");
      return resolve(false);
    });
  })
}
  

function checkCheckbox() {
  var is_checked = $("#terms").prop("checked");
  if (is_checked == false) {
    $(".checkbtn").addClass('checkbtn-disable');
    $(".checkmark").removeClass('chk-custom');
  } else {
    $(".checkbtn").removeClass('checkbtn-disable');
    $(".checkmark").addClass('chk-custom');
  }
}

function proceedCheckout() {
  process();
}

function process() {
  function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
  
  do {
    token=get_cookie('cart');
  } while(token == undefined);
  
  var myshopify_domain = '';
  
  try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
  
  checkout_url='/checkout';
  setTimeout(function(){
    $('.checkmark').removeClass('chk-custom');  
    $('.checkbtn').addClass('checkbtn-disable');
    $('#terms').prop('checked', false);
    
    // for(let i=0; i < arr.length; i++) {
    //   $("#item_"+arr[i]).hide();
    // }
  },3000);

  window.location.href=checkout_url;
}

$(document).ready(async (e) => {
  $('#planEditForm')?.find('[name="plan_edit_variant"]').on('change', function(e) {
    $('#mobilePlan')?.find('.planselection-wrap')?.find('.single-plan')?.removeClass('active');
    $(this).parent().addClass('active');
  })
})

$('#planEditForm')?.submit(async (e) => {
  e.preventDefault();
  
  $('#planEditForm')?.find('[type="submit"]')?.attr('disabled', 'disabled');

  cartData = await fetchCart();
  bindCartData();

  if (!cartData) {
    $('#planEditForm')?.find('[type="submit"]')?.attr('disabled', 'disabled');
    notify('error', "Cart Retrieval Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.")
    return;
  }

  const variantId = $('#planEditForm')?.find('[name="plan_edit_variant"]:checked')?.val();

  if (addCosmoCare == variantId) { // No Changes Selected
    $('#planEditForm')?.find('[type="submit"]')?.removeAttr('disabled');
    $('#mobilePlan')?.find('[data-dismiss="modal"]')?.click(); // Dismiss Modal
    return;
  }


  await addCosmoCare(variantId,null);
    cartData = await fetchCart(); // Refresh the cart page
   // bindCartData();
 
 setTimeout(function(){
  cancelEditPlan() // Dismiss Modal
 },2500);
   
 

  $('#planEditForm')?.find('[type="submit"]')?.removeAttr('disabled');
})

function initEditPlan() {
 // alert(addedCosmoCare);
  if (addedCosmoCare && addedCosmoCare) {
    //alert(addedCosmoCare);
    $('#planEditForm')?.find(`[name="plan_edit_variant"][value="${addedCosmoCare}"]`)?.prop('checked', true)?.trigger('change');
  } else {
    $('#planEditForm')?.find(`[name="plan_edit_variant"]`)?.last()?.prop('checked', true)?.trigger('change');
  }
  
  $('#mobilePlan')?.modal('show');
}
function cancelEditPlan() {
  $('#mobilePlan')?.modal('hide');  
}
